import api from "!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../node_modules/@muse-web/build/plugins/critical-css-plugin/cssCaptureLoader.js!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].use[2]!../../../../../node_modules/@muse-web/build/options/multilayer-rules/cssLayers/layerMarkerLoader.js??ruleSet[1].rules[8].use[3]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].use[4]!./TryForFreeCard.module.css";

var options = {"injectType":"styleTag"};

options.insert = function insertStyleTag(el) {
    // eslint-disable-next-line global-require
    require('@muse-web/build/options/multilayer-rules/insertStyleTag/styleInsert.module')(el)
};
options.singleton = false;

var update = api(content, options);



export default content.locals || {};